import { css } from 'styled-components';
import { THEME } from '@/common/styles/theme';

export const softieCardBase = css`
	position: relative;
	width: 100%;
	height: auto;
	aspect-ratio: 0.72;
	overflow: hidden;
	border-radius: 24px;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		border-radius: 16px;
	}
`;
